// extracted by mini-css-extract-plugin
export default {"content":"QYPdY","common_icon":"TQB1D","iconOffset":"bSVsc"};